import FooterLightComponent from "./components/footer-component-light";
import {RenderPosition, render} from "./utils/render";


export const renderFooterLight = () => {
  const container = document.querySelector(`.main-footer`);
  if (!container) {
    return;
  }

  const component = new FooterLightComponent({});

  const remoteAddrElement = container.querySelector(`.main-footer__remoteAddr`);
  if (remoteAddrElement) {
    remoteAddrElement.classList.remove(`overflowHidden`);
    const bottomWrap = component.getElement().querySelector(`.main-footer__bottom`);
    bottomWrap.append(remoteAddrElement);
  }
  render(container, component.getElement(), RenderPosition.BEFOREEND);
};
